 document.addEventListener("DOMContentLoaded", function () {
    const variantOptions = document.querySelectorAll('input[data-variant-id]');
    const productVariantsElement = document.getElementById('product-variants');
    const productVariants = JSON.parse(productVariantsElement.dataset.variants);
    const addToCartButton = document.querySelector('button[name="add"]');
    const notifyMeButton = document.querySelector('button[data-popup-open]'); 
    const productType = productVariantsElement.dataset.productType;
    const priceWrapper = document.querySelector('[data-price-wrapper]');
    const variantDropDown = document.querySelectorAll('.select-popout__option'); 
    

    let isContactButtonSet = false;

    function updateSoldOutState() {
        if (productType === "Loose Gems") {
            const isAnyVariantSoldOut = productVariants.some(variant => !variant.available);

            if (isAnyVariantSoldOut) {
                
                // chekBox
                variantOptions.forEach(option => {
                    option.classList.add('sold-out');
                });
                
                if (!isContactButtonSet) {
                    addToCartButton.textContent = 'Sold Out - Contact Us';
                    addToCartButton.addEventListener('click', function () {
                        window.location.href = 'https://www.valeriemadison.com/pages/contact-us';
                    });
                    isContactButtonSet = true;
                }
                
                //dropdown
                variantDropDown.forEach(option => {
                    option.classList.add('sold-out');
                });
                
                if (notifyMeButton) {
                    notifyMeButton.textContent = 'Sold Out - Contact Us';
                    notifyMeButton.addEventListener('click', function () {
                        window.location.href = 'https://www.valeriemadison.com/pages/contact-us';
                    });
                    isContactButtonSet = true;

                }

                //chnage the price opacity
                priceWrapper.style.opacity = '0.3';



            }
        }
    }

    updateSoldOutState();

    variantOptions.forEach(option => {
        option.addEventListener('change', updateSoldOutState);
    });
     

     variantDropDown.forEach(option => {
        option.addEventListener('click', function () {
            variantDropDown.forEach(opt => opt.classList.add('sold-out'));
        });
    });
    
});
